import { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { FormikProps } from 'formik';
import { get } from 'lodash';

export abstract class FormComponent<F, P = Record<string, never>, S = Record<string, never>> extends Component<P, S> {
    // The form generic value is not required to be defined for this functions, it works generic for all forms
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    protected hasError(form: FormikProps<any>, propertyName: string) {
        return !!this.getError(form, propertyName);
    }

    // The form generic value is not required to be defined for this functions, it works generic for all forms
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    protected getError(form: FormikProps<any>, propertyName: string) {
        const error = get(form.errors, propertyName);
        // nested objects or arrays will always have touched === undefined -> check also for submitCount as a fix
        // see issue https://github.com/jaredpalmer/formik/issues/738
        const touched = get(form.touched, propertyName) || form.submitCount > 0;
        // Typings rule the error to be generic, but we always specify the schemas with yup, and that requires a string
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const errorId = touched && error && (error as any);
        if (errorId && typeof errorId === 'string') {
            return <FormattedMessage id={errorId} />;
        }
        return null;
    }

    protected setFieldValue(formikBag: FormikProps<F>, fieldName: string) {
        // The value is any per definition of formik
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return (value: any) => {
            formikBag.setFieldValue(fieldName, value);
        };
    }
}
